var map = {
	"./behavior.png": 70497,
	"./camera.png": 29962,
	"./food.png": 41910,
	"./google-pin.png": 39333,
	"./icon-add-appt.png": 85193,
	"./icon-add-pet.png": 59662,
	"./icon-add.png": 10719,
	"./icon-arrow.png": 21294,
	"./icon-brand-broadcast.png": 70639,
	"./icon-broadcast.png": 20557,
	"./icon-calendar.png": 58425,
	"./icon-calendar2.png": 80409,
	"./icon-calendar3.png": 6228,
	"./icon-camera-plus.png": 78238,
	"./icon-cash-dark.svg": 51732,
	"./icon-cash-light.svg": 61917,
	"./icon-cash.png": 84459,
	"./icon-cashier.png": 46709,
	"./icon-cashier.svg": 57141,
	"./icon-cat.png": 60474,
	"./icon-chat.png": 80570,
	"./icon-check-select.png": 14281,
	"./icon-check.png": 90758,
	"./icon-checklist.png": 16297,
	"./icon-clock.png": 70051,
	"./icon-delete-copy.png": 54198,
	"./icon-direct-message.png": 48225,
	"./icon-doctor.png": 99077,
	"./icon-dog.png": 67487,
	"./icon-edit.svg": 28423,
	"./icon-email.png": 8814,
	"./icon-email2.png": 98243,
	"./icon-female-sign-white.png": 3991,
	"./icon-female-sign.png": 7108,
	"./icon-female-white-alt.png": 56748,
	"./icon-gift.png": 78406,
	"./icon-goto-activity-white.png": 54373,
	"./icon-goto-activity.png": 52222,
	"./icon-info.png": 51929,
	"./icon-insurance.png": 37985,
	"./icon-line.png": 49711,
	"./icon-male-sign-white.png": 65977,
	"./icon-male-sign.png": 44879,
	"./icon-male-white-alt.png": 27621,
	"./icon-medical-record.svg": 32500,
	"./icon-messenger.png": 91556,
	"./icon-move-updown.png": 14248,
	"./icon-notepad.png": 36194,
	"./icon-onesignal.png": 52424,
	"./icon-paperclip.png": 102,
	"./icon-pill-bottle-dark.svg": 14930,
	"./icon-pill-bottle.svg": 2596,
	"./icon-plus-circle.png": 95864,
	"./icon-printer.png": 6632,
	"./icon-record.png": 61995,
	"./icon-save-white.png": 68211,
	"./icon-timeline-bloodbag.png": 50542,
	"./icon-timeline-blooddrop.png": 76776,
	"./icon-timeline-prevention.png": 54772,
	"./icon-timeline-vaccine.png": 93001,
	"./icon-toggle-button-active.png": 44145,
	"./icon-toggle-button.png": 89446,
	"./icon-user-add.png": 24006,
	"./icon-vaccine.png": 75242,
	"./icon-vet.png": 30207,
	"./icon-vremind-broadcast.png": 20013,
	"./medal-bronze.svg": 97214,
	"./medal-gold.svg": 17569,
	"./medal-silver.svg": 19167,
	"./message-three-points.png": 66473,
	"./orther.png": 88514,
	"./prevention.png": 56146,
	"./sick.png": 11960,
	"./weight.png": 6675
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36075;